import React from "react";
import {Button} from "antd";

interface NextButtonProps {
    goToNextTab: () => void;
    disabled?: boolean;
}

const NextButton = ({goToNextTab, disabled=false}: NextButtonProps) => {
    return (
        <Button
            disabled={disabled}
            onClick={goToNextTab}
        >
            Next
        </Button>
    );
};

export default NextButton;
